import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const correctedQuery = getProductListDataViewProperty(state, "correctedQuery");
    const { productFilters } = state.pages.productList;

    return {
        query: correctedQuery || productFilters.query,
        view: state.pages.productList.view,
    };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 0px 15px;
    font-size: 18px;
    color: black;
    font-weight: 500;
    gap: 15px;
    margin-top: 30px;
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                flex-direction: column;
                margin-bottom: 25px;
            `,
            css`
                flex-direction: column;
                margin-bottom: 25px;
            `,
            css`
                flex-direction: column;
                margin-bottom: 15px;
            `,
        ]);
    }}
`;

const Left = styled.div`
    flex: 1 1;
    align-items: flex-start;
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                text-align: left;
            `,
            css`
                text-align: left;
            `,
            css`
                text-align: left;
            `,
        ]);
    }}
`;

const Center = styled.div`
    flex: 1 1;
    align-items: center;
    justify-content: center;
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                display: none;
            `,
            css`
                display: none;
            `,
            css`
                display: none;
            `,
            css`
                display: none;
            `,
        ]);
    }}
`;

const Right = styled.div`
    flex: 1 1;
    align-items: flex-end;
    text-align: right;
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                display: none;
            `,
            css`
                display: none;
            `,
        ]);
    }}
`;

const titleStyles: InjectableCss = {
    css: css`
        margin: 24px 0;
        padding: 0px 15px;

        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                    margin: 18px 0 0;
                `,
                css`
                    margin: 18px 0 0;
                `,
            ]);
        }}
    `,
};
const ProductListControlsContainer: FC<Props> = ({ id, view, query }) => {
    return (
        <>
            {query && (
                <Typography variant="h4" {...titleStyles} data-test-selector="productListQueryText">
                    {translate("Results for: ")}
                    <span style={{ fontWeight: 700 }}>{query}</span>
                </Typography>
            )}
            <Container id="paginationTop">
                <Left>
                    <Zone contentId={id} zoneName="Content00" />
                </Left>
                <Center>
                    <Zone contentId={id} zoneName="Content01" />
                </Center>
                <Right>
                    <Zone contentId={id} zoneName="Content03" />
                </Right>
            </Container>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ProductListControlsContainer),
    definition: {
        group: "Product List",
        displayName: "List Controls Container",
        allowedContexts: ["ProductListPage"],
    },
};

export default widgetModule;
